import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../../services/order/order.service';

@Component({
  selector: 'app-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.scss'],
})
export class PersonalDataComponent implements OnInit {
  get lucrative_activity(): string {
    return this.getValue('lucrative_activity');
  }

  get employment_terminated(): string {
    return this.getValue('employment_terminated');
  }

  get civil_status(): string {
    return `civil_status.${this.getValue('civil_status')}`;
  }

  get gender(): string {
    return this.getValue('gender');
  }

  get pension_fund(): string {
    return this.getValue('pension_fund');
  }

  constructor(private readonly orderService: OrderService) {}

  ngOnInit(): void {}

  getValue(name: string): string {
    return this.orderService.getValue(name);
  }
}
